import {Dispatch} from "redux";
import IClient from "./IClient";

export function  saveClients(clients:IClient[]){
    return (dispatch: Dispatch) => {

        return dispatch({
            type: 'SAVE_CLIENTS',
            clients
        });
    };
}
